"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiSubClient = void 0;
class ApiSubClient {
    constructor(adminLinks, axios) {
        this.adminLinks = adminLinks;
        this.axios = axios;
    }
    getLinkOrThrow(adminLinkKey) {
        if (this.adminLinks &&
            this.adminLinks[adminLinkKey] &&
            this.adminLinks[adminLinkKey] !== null) {
            return this.adminLinks[adminLinkKey];
        }
        else {
            console.log(this.adminLinks);
            console.log(adminLinkKey);
            throw new Error(`Not authorized for ${adminLinkKey}`);
        }
    }
    getLink(adminLinkKey) {
        if (this.adminLinks && this.adminLinks[adminLinkKey]) {
            return this.adminLinks[adminLinkKey];
        }
        else {
            return null;
        }
    }
}
exports.ApiSubClient = ApiSubClient;
//# sourceMappingURL=ApiSubClient.js.map